export default __webpack_public_path__ + "static/media/008-boy-3.b1220ac8.svg";